import { Injectable } from '@angular/core';
import {
  ADMIN_ROLE,
  REFERENCER_ROLE,
  CONTRIBUTOR_ROLE,
  SUPERADMIN_ROLE,
} from '../../constant/app.constants';
import { SessionService } from '../authentication/session.service';

@Injectable()
export class UserService {
  constructor(private readonly sessionService: SessionService) {}

  hasRole(role: string): boolean {
    return this.sessionService.getUserInfo()?.roles?.includes(role) ?? false;
  }

  hasAnyRole(roles: string[]): boolean {
    return roles.some((role) => this.hasRole(role));
  }

  isAdmin(): boolean {
    return this.hasRole(ADMIN_ROLE);
  }
  isSuperAdmin(): boolean {
    return this.hasRole(SUPERADMIN_ROLE);
  }

  isReferencer(): boolean {
    return this.hasRole(REFERENCER_ROLE);
  }

  isContributor(): boolean {
    return this.hasRole(CONTRIBUTOR_ROLE);
  }
}
